import axios from 'axios'

axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const controller = 'OrderTracking'

export const getOrderTracking = () => {
  return axios.get(`/${controller}`)
}

export const getOrderTrackingByCustomer = (id) => {
  return axios.get(`/${controller}/Customer?customerId=${id}`)
}

export const getOrderTrackingByOrder = (id) => {
  return axios.get(`/${controller}/Order?orderId=${id}`)
}

export const setFeedback = (data) => {
  return axios.put(`/${controller}`, data)
}
